import { __awaiter } from "tslib";
import log from 'pathfinder/utils/log';
export default function getDiscussionsCategoriesData() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const currentPage = (yield window.SilverSurferSDK.getContext()).current;
            if (!currentPage) {
                return null;
            }
            const productId = currentPage.productId;
            const response = yield fetch(`/wikia.php?controller=DiscussionForum&method=getForums`, {
                headers: {
                    'X-Wiki-Id': productId,
                },
            });
            if (response.ok) {
                // TODO: remove this when we have a proper response type
                // eslint-disable-next-line
                const jsonBody = yield response.json();
                // eslint-disable-next-line
                const categories = jsonBody._embedded['doc:forum'];
                return categories;
            }
        }
        catch (err) {
            // eslint-disable-next-line
            log.error(err);
        }
        return null;
    });
}
